import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'shared-element-list',
  templateUrl: './element-list.component.html',
  styles: []
})
export class ElementListComponent {
  @Input('data')
  public data: any[] = [];

  @Input('totalPages')
  public totalPages: number | undefined;

  @Input('currentPage')
  public currentPage: number = 1;

  @Input('displayNameProp')
  public displayNameProp: string = '';

  @Output('onRemoveEvent')
  public onRemoveEvent: EventEmitter<any> = new EventEmitter();

  @Output('onLoadMoreEvent')
  public onLoadMoreEvent: EventEmitter<void> = new EventEmitter();

  /**
   * Remove an element from the list.
   * @param option Object to remove.
   */
  public onRemove(option: any): void {
    this.onRemoveEvent.emit(option);
  }

  /**
   * Load more items in the list.
   */
  public onLoadMore(): void {
    this.onLoadMoreEvent.emit();
  }
}